import { render, staticRenderFns } from "./modal-pet-weight.vue?vue&type=template&id=939892bc&scoped=true&lang=pug"
import script from "./modal-pet-weight.js?vue&type=script&lang=js&external"
export * from "./modal-pet-weight.js?vue&type=script&lang=js&external"
import style0 from "./modal-pet-weight.vue?vue&type=style&index=0&id=939892bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939892bc",
  null
  
)

export default component.exports